<template>
  <div class="clientDynamic">
    <el-select v-model="value" style="margin-bottom:20px">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>

    <!-- 修改记录 -->
    <section
      class="sections sectionBig"
      v-infinite-scroll="load"
      v-show="isShow4"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="300"
      :infinite-scroll-distance="30"
    >
      <div v-for="res in amendList" :key="res.id" style="overflow:auto">
        <h4>{{ res.date }}</h4>
        <el-descriptions
          :column="3"
          border
          :contentStyle="{ width: '240px' }"
          :label-style="{ width: '110px' }"
          style="margin: 20px 0;"
          v-for="(item, key) in res.children"
          :key="key"
        >
          <el-descriptions-item v-if="item.relaname">
            <template slot="label">姓名</template>{{ item.relaname }}
          </el-descriptions-item>
          <el-descriptions-item v-if="item.sex">
            <template slot="label">性别</template>{{ item.sex }}
          </el-descriptions-item>
          <el-descriptions-item v-if="item.intention_level">
            <template slot="label">意向等级</template>{{ item.intention_level }}
          </el-descriptions-item>
          <el-descriptions-item v-if="item.loan">
            <template slot="label">贷款状态</template>{{ item.loan }}
          </el-descriptions-item>
          <el-descriptions-item v-if="item.property">
            <template slot="label">房产状态</template>{{ item.property }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">经纪人</template>{{ item.staff_name }} --
            {{ item.create_time }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="footsteps">
        <p v-text="isLoadMore ? '没有更多了' : '加载中...'"></p>
      </div>
    </section>
    <!-- 代办事项 -->
    <section
      class="planRecord sectionBig"
      v-show="isShow2"
      v-infinite-scroll="load"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="300"
      :infinite-scroll-distance="30"
    >
      <div v-for="res in PlanRecordList" :key="res.id">
        <h4>{{ res.date }}</h4>
        <el-descriptions
          :column="3"
          border
          :contentStyle="{ width: '240px' }"
          :label-style="{ width: '110px' }"
          style="margin: 20px 0;"
          v-for="(item, key) in res.children"
          :key="key"
        >
          <el-descriptions-item>
            <template slot="label">待办内容</template>{{ item.content }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">待办时间</template>{{ item.plan_time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">待办状态</template
            >{{ item.is_complete == 1 ? '已完成' : '未完成' }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">经纪人</template>{{ item.staff_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">创建时间</template>{{ item.create_time }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="footsteps">
        <p v-text="isLoadMore ? '没有更多了' : '加载中...'"></p>
      </div>
    </section>

    <!-- 报备记录 -->
    <section
      class="report sectionBig"
      v-show="isShow3"
      v-infinite-scroll="load"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="300"
      :infinite-scroll-distance="30"
    >
      <div v-for="res in information" :key="res.id">
        <h4>{{ res.date }}</h4>
        <el-descriptions
          :column="3"
          border
          :contentStyle="{ width: '240px' }"
          :label-style="{ width: '110px' }"
          style="margin: 20px 0;"
          v-for="(item, key) in res.children"
          :key="key"
        >
          <el-descriptions-item>
            <template slot="label">带看时间 </template>{{ item.order_time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">到访时间</template>{{ item.appoint_time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">登记时间</template>{{ item.check_time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">带看楼盘</template>{{ item.promotion_title }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">报备渠道商</template>{{ item.channel_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">经纪人</template>{{ item.staff_name }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">佣金标准</template>
            <el-tooltip
              :content="item.commission_standard"
              popper-class="seemore"
              placement="top-start"
            >
              <div class="ruleBox">{{ item.commission_standard }}</div>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">回款周期</template>
            <el-tooltip
              :content="item.payment_cycle"
              popper-class="seemore"
              placement="top-end"
            >
              <div class="ruleBox">{{ item.payment_cycle }}</div>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">结佣规则</template>
            <el-tooltip
              :content="item.commission_rule"
              popper-class="seemore"
              placement="top-end"
            >
              <div class="ruleBox">{{ item.commission_rule }}</div>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">凭证</template>
            <el-image
              v-for="(item4, index) in item.thumb_group"
              :key="index"
              style="width: 100px;height: 100px"
              :src="item4"
              fit="cover"
              :preview-src-list="item.thumb_group"
            >
            </el-image>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="footsteps">
        <p v-text="isLoadMore ? '没有更多了' : '加载中...'"></p>
      </div>
    </section>

    <!-- 跟踪记录 -->
    <section
      class="sectionBig trackRecord"
      v-show="isShow1"
      v-infinite-scroll="load"
      :infinite-scroll-immediate="false"
      :infinite-scroll-delay="300"
      :infinite-scroll-distance="30"
    >
      <div
        v-for="(res, index) in trackRecordList"
        :key="index + 1"
        style="margin-bottom: 15px;"
      >
        <h4>{{ res.date }}</h4>
        <div
          v-for="(item, index) in res.children"
          :key="index + 2"
          class="recordLi"
        >
          <div class="banner">
            <p>{{ item.track_status }}</p>
            <div class="foot">
              <p>跟进员工：{{ item.staff_name }}</p>
              <p v-show="item.trace_mode ? true : false">
                跟进方式：{{ item.trace_mode }}
              </p>
              {{ item.create_time }}
            </div>
          </div>

          <div class="content">
            <div class="content1">
              <p>{{ item.content }}</p>
              <div style="margin:10px 0">
                <el-image
                  v-for="(item4, index) in item.thumb_group"
                  :key="index"
                  fit="cover"
                  style="width: 100px;height: 100px;margin-right: 10px;"
                  :src="item4"
                  :preview-src-list="item.thumb_group"
                >
                </el-image>
              </div>
            </div>

            <div class="appendRecord" v-if="item.append_record.length">
              <p>追加内容:</p>
              <div
                class="foot1"
                v-for="(item1, index) in item.append_record"
                :key="index + 2"
              >
                <div class="content">
                  <p>{{ item1.content }}</p>
                  <div class="box">{{ item1.create_time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footsteps">
        <p v-text="isLoadMore ? '没有更多了' : '加载中...'"></p>
      </div>
    </section>

    <el-empty v-if="isShow" description="暂无数据"></el-empty>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      Type: Number,
      default: 0,
    },
    index: {
      Type: String,
      default: '',
    },
  },
  data() {
    return {
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      options: [
        {
          value: '1',
          label: '跟进记录',
        },
        {
          value: '2',
          label: '待办事项',
        },
        {
          value: '3',
          label: '报备记录',
        },
        {
          value: '4',
          label: '修改记录',
        },
      ],
      value: '1',
      search: {
        page: 1,
        limit: 10,
      },
      handler: false,
      amendList: [], //修改记录
      PlanRecordList: [], //代办事项
      information: [], //报备记录
      trackRecordList: [], //跟踪记录
      isLoadMore: false, //是否加载中
    }
  },
  watch: {
    index(val) {
      if (val == 2) {
        this.isShow1 = true
        this.getTrackRecords()
      } else {
        ;(this.search.page = 1), (this.value = '1'), (this.trackRecordList = [])
        this.amendList = []
        this.PlanRecordList = []
        this.information = []
      }
    },
    value: {
      immediate: true,
      handler(val) {
        this.search.page = 1
        this.isLoadMore = false
        this.isShow1 = false
        this.isShow2 = false
        this.isShow4 = false
        this.isShow3 = false
        this.isShow = false
        this.$nextTick(() => {
          if (val == 2) {
            this.isShow2 = true
            this.getPlanRecordList(true)
          }
          if (val == 4) {
            this.isShow4 = true
            this.getAmendList(true)
          }
          if (val == 3) {
            this.isShow3 = true
            this.getReportRecord(true)
          }
          if (val == 1 && this.index == 2) {
            this.isShow1 = true
            this.getTrackRecords(true)
          }
        })
      },
    },
    'search.page': {
      handler(val) {
        if (val != 1) {
          if (this.value == 1 && this.index == 2) this.getTrackRecords()
          if (this.value == 2) this.getPlanRecordList()
          if (this.value == 3) this.getReportRecord()
          if (this.value == 4) this.getAmendList()
        }
      },
    },
  },
  methods: {
    async getTrackRecords(rehash) {
      console.log(123)
      //跟踪事项
      if (rehash) this.trackRecordList = []
      const res = await this.$api.trackRecord({
        ...this.search,
        id: this.id,
      })
      if (res.data.length == 0 && this.value == 1 && this.search.page == 1) {
        this.isShow = true
        this.isShow1 = false
      }
      console.log(this.isLoadMore, '加载跟踪事项')
      if (res.data.length < this.search.limit) {
        console.log('不可以加载')
        this.isLoadMore = true
      } else {
        console.log('可以加载')
        this.isLoadMore = false
      }
      // this.trackRecordList = this.trackRecordList.concat(res.data)

      let trackRecordList = {}
      res.data.forEach((item, index) => {
        if (trackRecordList[item.date]) {
          trackRecordList[item.date].children.push(item)
        } else {
          trackRecordList[item.date] = {
            date: item.date,
            children: [item],
          }
        }
      })

      // for (let i in trackRecordList) {
      //   this.trackRecordList.push(trackRecordList[i])
      // }
      for (let i in trackRecordList) {
        let ind = this.trackRecordList.findIndex((item) => {
          return item.date == trackRecordList[i].date
        })

        if (ind == -1) this.trackRecordList.push(trackRecordList[i])
        else
          this.trackRecordList[ind].children.push(
            ...trackRecordList[i].children
          )
      }
      console.log(this.trackRecordList)
    },
    async getReportRecord(rehash) {
      //报备事项
      console.log('报备事项')
      if (rehash) this.information = []
      const res = await this.$api.reportRecord({
        id: this.id,
        ...this.search,
      })
      console.log(res, 'baobei')

      if (res.data.length == 0 && this.value == 3 && this.search.page == 1) {
        this.isShow = true
        this.isShow3 = false
      }
      console.log(this.isLoadMore, '加载报备事项')
      if (res.data.length < this.search.limit) {
        console.log('不可以加载')
        this.isLoadMore = true
      } else {
        console.log('可以加载')
        this.isLoadMore = false
      }
      // this.information = this.information.concat(res.data)

      let information = {}
      res.data.forEach((item, index) => {
        if (information[item.date]) {
          information[item.date].children.push(item)
        } else {
          information[item.date] = {
            date: item.date,
            children: [item],
          }
        }
      })

      for (let i in information) {
        let ind = this.information.findIndex((item) => {
          return item.date == information[i].date
        })
        console.log(ind, '159')
        if (ind == -1) this.information.push(information[i])
        else this.information[ind].children.push(...information[i].children)
      }
    },
    async getPlanRecordList(rehash) {
      //代办事项
      if (rehash) this.PlanRecordList = []
      const res = await this.$api.planRecord({
        id: this.id,
        ...this.search,
      })
      console.log(res.data, 'daiban')
      if (res.data.length == 0 && this.value == 2 && this.search.page == 1) {
        this.isShow = true
        this.isShow2 = false
      }
      console.log(this.isLoadMore, '加载代办事项')
      if (res.data.length < this.search.limit) {
        console.log('不可以加载')
        this.isLoadMore = true
      } else {
        this.isLoadMore = false
        console.log(this.isLoadMore, '可以加载')
      }
      let PlanRecordList = {}
      res.data.forEach((item, index) => {
        if (PlanRecordList[item.date]) {
          PlanRecordList[item.date].children.push(item)
        } else {
          PlanRecordList[item.date] = {
            date: item.date,
            children: [item],
          }
        }
      })

      for (let i in PlanRecordList) {
        let ind = this.PlanRecordList.findIndex((item) => {
          return item.date == PlanRecordList[i].date
        })
        console.log(ind, '159')
        if (ind == -1) this.PlanRecordList.push(PlanRecordList[i])
        else
          this.PlanRecordList[ind].children.push(...PlanRecordList[i].children)
      }
      // for (let i in PlanRecordList) {
      //   this.PlanRecordList.push(PlanRecordList[i])
      // }
    },
    async getAmendList(rehash) {
      if (rehash) this.amendList = []
      const res = await this.$api.customerInfoRecord({
        id: this.id,
        ...this.search,
      })
      if (res.data.length == 0 && this.value == 4 && this.search.page == 1) {
        this.isShow = true
        this.isShow4 = false
      }

      if (res.data.length < this.search.limit) {
        console.log('不可以加载')
        this.isLoadMore = true
      } else {
        console.log('可以加载')
        this.isLoadMore = false
      }

      let amendList = {}
      res.data.forEach((item, index) => {
        if (amendList[item.date]) {
          amendList[item.date].children.push(item)
        } else {
          amendList[item.date] = {
            date: item.date,
            children: [item],
          }
        }
      })
      // for (let i in amendList) {
      //   this.amendList.push(amendList[i])
      // }

      for (let i in amendList) {
        let ind = this.amendList.findIndex((item) => {
          return item.date == amendList[i].date
        })
        console.log(ind, '159')
        if (ind == -1) this.amendList.push(amendList[i])
        else this.amendList[ind].children.push(...amendList[i].children)
      }
      // this.amendList = this.amendList.concat(res.data)
    },
    load() {
      if (this.index != 2) return
      console.log('触底被执行')
      if (!this.isLoadMore) {
        //此处判断，上锁，防止重复请求
        this.isLoadMore = true
        this.search.page += 1
      }
    },
  },
}
</script>

<style lang="scss">
.ruleBox {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 240px;
}
.seemore {
  width: 500px;
  line-height: 20px;
}
.clientDynamic {
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .el-step__icon-inner {
    display: none;
  }

  .sectionBig {
    height: calc(100vh - 215px);
    position: relative;
    padding-right: 5px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e4e7ed;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
    }
  }

  .sections {
    .el-step__main {
      display: flex;

      .el-step__description {
        padding: 8px 0 0 20px;
      }
    }

    .el-step__icon {
      width: 15px;
      height: 15px;
    }

    .el-step.is-vertical .el-step__line {
      width: 2px;
      top: 10px;
      bottom: 0px;
      left: 6px;
    }
  }

  .planRecord {
    .bigBox {
      margin: 20px 10px 20px 0;
      box-sizing: border-box;
      width: 400px;
      height: 300px;
      background: #eee;
      border-radius: 30px;

      .uls {
        display: flex;
        justify-content: space-between;
      }

      li {
        margin: 20px;
      }
    }
  }
  .footsteps {
    width: 100%;
    margin: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999999;
    font-size: 12px;
  }
  .trackRecord {
    overflow: auto;
    .recordLi {
      padding: 10px 30px 0;
      .banner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        color: #999;
        & > p {
          font-size: 16px;
          color: #333;
        }
        .foot {
          font-size: 13px;
          color: #999;
          display: flex;
          p {
            margin-right: 20px;
          }
        }
      }
      .content {
        min-height: 30%;
        padding-top: 10px;
        .content1 {
          background: #fcfcfc;
          margin-bottom: 10px;
          padding: 10px 10px 1px 10px;
          box-sizing: border-box;
        }
      }
      .appendRecord {
        font-size: 14px;
        .foot1 {
          padding-left: 20px;
          margin-top: 10px;
          .box {
            color: #999;
            font-size: 13px;
            margin-top: 5px;
          }
          .content {
            background: #fcfcfc;
            padding: 10px;
          }
        }
      }
    }
  }
  .report {
    .time {
      color: #999999;
      line-height: 40px;
    }
    .bigBox {
      .status {
        padding: 15px 0;
        display: flex;
        justify-content: space-around;
        border: 1px solid #e8e8e8;

        .status1 {
          width: 23%;
          color: #999999;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .sectionSon {
        padding: 0 55px;
        box-sizing: border-box;
        border: 1px solid #e8e8e8;
        border-top: none;
        img {
          width: 90%;
          border-radius: 6px;
        }
        .rule {
          .rt {
            padding-left: 20px;
            box-sizing: border-box;
          }
        }
        .flex {
          display: flex;
          justify-content: space-between;
          line-height: 40px;
          .lt {
            color: #999;
          }
          .rt {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            color: #333333;
          }
        }
        .house {
          .rt {
            color: #fc7a16;
          }
        }
        .thumb {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
